import API from "../Services/API";
import Model from "./Model";

const useDocuments = () => {
    return Model({
        stateKey: ['documents'],
        fetchData: () => API.get('documents'),
        alwaysRefresh: true,
        returnDataKey: 'documents',
        defaultLoadingError: 'Sorry, there was an error loading your documents.',
        registerAdditionalMethods: (opts) => {
            return {
                addDocument: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/documents', data),
                        'Document added',
                        true,
                    );
                },
                deleteDocument: (documentId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete('/documents/' + documentId),
                        'Document deleted',
                        true,
                    );
                },
            }
        }
    });
}

const useDocument = (id) => {
    return Model({
        stateKey: ['document', id],
        fetchData: () => API.get(`documents/${id}`),
        alwaysRefresh: true,
        returnDataKey: 'document',
        defaultLoadingError: 'Sorry, there was an error loading your document.',
        registerAdditionalMethods: (opts) => {
            return {
                updateDocument: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/documents/${id}`, data),
                        'Document updated',
                        true,
                    );
                },
                generateDocument: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/documents/${id}/generate`, data),
                        'Your document is being generated',
                        true,
                    );
                },
                updateVisibilityOptions: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/documents/${id}/visibilityOptions`, data),
                        'Visibility options updated',
                        true,
                    );
                },
                checkForGenerationComplete: async (generateId) => {
                    await opts.refresh();
                    const doc = opts.model();
                    console.log('Checking for generation complete', doc.generateId, generateId)
                    return doc.generateId === generateId;
                }
            }
        }
    });
}

const categories = {
    'Insurance': 'Insurance-related documents, such as public liability.',
    'Certifications': 'Professional certifications or qualifications that the business or employees hold.',
    'Agreements': 'Contracts or agreements, such as between the business and customers.',
    'Data Protection': 'Documents related to data protection, such as privacy policies or data processing agreements.',
    'Safety': 'Documents related to safety, such as risk assessments or safety policies.',
    'Service Guides': 'Service guides, such as what is or is not included in a service.',
    'Other': 'Other documents.',
}

export {
    useDocuments,
    useDocument,
    categories,
}
